import { HttpStatusCode } from 'axios';
import {API} from '../config/config';
//import axios from 'axios';
import buildResponse from './helpers';

const StoresService = {
  getAll: () => getStores(),
  searchStockMovements: (storeId, query) => searchStockMovements(storeId, query),
  searchStockMovementsPaginated: (storeId, query) => searchStockMovementsPaginated(storeId, query),
};

const getStores = async () => {
  try {
    var response = await API.get('/stores')
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const searchStockMovements = async (storeId, query) => {
  try {
    var response = await API.get(`/stores/${storeId}/stockmovements?${query || ''}`)
    const body = response.data
    if (Array.isArray(body)) return body
    if (Array.isArray(body?.data)) return body.data
    if (Array.isArray(body?.items)) return body.items
    return []
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const searchStockMovementsPaginated = async (storeId, query) => {
  try {
    const params = new URLSearchParams(query || '')
    const page = Number(params.get('page') || 1)
    const limit = Number(params.get('limit') || 50)
    params.set('page', String(page))
    params.set('limit', String(limit))

    var response = await API.get(`/stores/${storeId}/stockmovements?${params.toString()}`)
    const body = response.data || {}

    const items = Array.isArray(body)
      ? body
      : Array.isArray(body?.data)
        ? body.data
        : Array.isArray(body?.items)
          ? body.items
          : []

    const totalPages = Number(body?.totalPages || body?.pagination?.totalPages)
    const total = Number(body?.total || body?.pagination?.total || body?.totalItems)

    const hasMore = Number.isFinite(totalPages)
      ? page < totalPages
      : Number.isFinite(total)
        ? page * limit < total
        : items.length >= limit

    return {
      items,
      page,
      limit,
      total,
      totalPages,
      hasMore,
    }
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

export default StoresService;
